import { z } from 'zod';

const values = ['LOADING', 'DISABLED', 'ENABLED'] as const;
export const activationStatusSchema = z.enum(values);

export const ActivationStatus = activationStatusSchema.enum;

export type ActivationStatus = z.infer<typeof activationStatusSchema>;
